module.exports = "pegasus/assets/theme6/medium/6.jpg";